import {
  BankPaymentIcon,
  IconPropsType, // CentralPayIcon,
  MefeteIcon,
  PaparaIcon,
} from '@repo/icons';

export const PaymentIconsMap: { [key: string]: React.FC<IconPropsType> } = {
  centralpay: BankPaymentIcon,
  mefete: MefeteIcon,
  papara: PaparaIcon,
} as const;

export const PaymentIcon = ({ payment, className }: IconPropsType & { payment?: string }) => {
  if (!payment) return null;

  const PaymentIconComponent = PaymentIconsMap?.[payment?.toLowerCase() as keyof typeof PaymentIconsMap];

  if (!PaymentIconComponent) return null;

  return <PaymentIconComponent className={className} />;
};
